import { em } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  margin-left: ${em(-21)};
  align-items: baseline;
  padding-top: ${em(10)};
  text-align: left;
  padding-left: ${em(8)};

  ${p => p.theme.mq.upMd} {
    padding-left: ${em(10)};
  }

  ${p => p.theme.mq.upLg} {
    padding-left: ${em(5)};
  }
`

export const PlusIcon = styled.div`
  margin-right: ${em(3)};
  transform: translateY(${em(2)});
  width: ${p => p.theme.typography.fontSizeMd};
  height: ${p => p.theme.typography.fontSizeMd};
  flex: 0 0 auto;
`
